/**
 * Deletes Bazaarvoice's hover rules for the rating type.
 *
 * Bazaarvoice ships rules like
 *
 *   [data-bv-show="rating_summary"] .bv_main_container .bv_numReviews_text:hover
 *     { font-size: 13px !important; font-family: ... !important; ... }
 *
 * which shrink the review count when the pointer is over it. The line box gets
 * shorter and everything below the rating moves up by about 3px.
 *
 * Overriding them with more specific CSS was the obvious answer and it did not
 * hold, so the rules are removed from the stylesheet instead. There is no
 * cascade to lose that way. Bazaarvoice re-injects its styles when it
 * re-renders, so this re-runs on new stylesheets rather than once.
 */
(function () {
  // Any Bazaarvoice hover rule that can change the size of the row. Their
  // cursor:pointer rules are left alone — they affect nothing but the pointer.
  var TARGET = /bv_/;
  var GEOMETRY = /(line-height|font-size|height|padding|margin)/;
  var removed = 0;

  function strip() {
    for (var s = 0; s < document.styleSheets.length; s++) {
      var sheet = document.styleSheets[s];
      var rules;
      try {
        rules = sheet.cssRules;
      } catch (e) {
        continue; // cross-origin, not ours to read
      }
      if (!rules) continue;

      // Backwards: deleting shifts the indices of everything after it.
      for (var i = rules.length - 1; i >= 0; i--) {
        var sel = rules[i].selectorText || "";
        if (sel.indexOf(":hover") === -1) continue;
        if (!TARGET.test(sel)) continue;
        if (!GEOMETRY.test(rules[i].cssText || "")) continue;
        // Leave our own rules alone; they are what holds the size steady.
        if (sel.indexOf("html body") === 0) continue;
        try {
          sheet.deleteRule(i);
          removed++;
        } catch (e) {
          /* some sheets refuse deletion; the CSS override still applies */
        }
      }
    }
    window.__bvHoverRulesRemoved = removed;
  }

  strip();
  // Bazaarvoice loads and re-renders asynchronously.
  [200, 600, 1200, 2500, 5000].forEach(function (t) {
    setTimeout(strip, t);
  });
  // Bazaarvoice injects more CSS on the first interaction, after every timer
  // above has already run — the first hover was correct and every one after it
  // was not. Stripping again on the interaction itself closes that window.
  ["mouseover", "focusin", "touchstart"].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && e.target.closest && e.target.closest("[data-bv-show]")) strip();
    }, true);
  });

  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      for (var j = 0; j < list[i].addedNodes.length; j++) {
        var n = list[i].addedNodes[j];
        if (n.nodeType === 1 && (n.tagName === "STYLE" || n.tagName === "LINK")) {
          strip();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
